import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import FulfilmentLocationSearch from '@afosto/app-components-react/FulfilmentLocationSearch';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import validationSchema, { singleLocationValidationSchema } from './validations';

const FulfilmentLocationSearchForm = ({
  filterSuggestions,
  locations,
  multiple,
  onSubmit,
  onCancel,
  renderActions,
  validationSchema: providedValidationSchema,
}) => {
  const fallbackValue = multiple ? [] : null;
  const fallbackSchema = multiple ? validationSchema : singleLocationValidationSchema;
  const form = useForm({
    validationSchema: providedValidationSchema || fallbackSchema,
    defaultValues: {
      locations: locations?.length > 0 ? locations : fallbackValue,
    },
    onSubmit,
    onCancel,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form} renderActions={renderActions}>
        <FulfilmentLocationSearch
          name="locations"
          multiple={multiple}
          filterOptions={filterSuggestions}
        />
      </Form>
    </LoadingWrapper>
  );
};

FulfilmentLocationSearchForm.propTypes = {
  filterSuggestions: PropTypes.func,
  locations: PropTypes.array,
  multiple: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  renderActions: PropTypes.bool,
  validationSchema: PropTypes.object,
};

FulfilmentLocationSearchForm.defaultProps = {
  filterSuggestions: undefined,
  locations: [],
  multiple: true,
  onSubmit: undefined,
  onCancel: undefined,
  renderActions: true,
  validationSchema: undefined,
};

export default FulfilmentLocationSearchForm;
